import type {
  DeanonymizationEvent,
  DeanonymizationProviderReadyEvent,
  WebDataEvent,
} from '../../../shared/types'
import { CHILIPIPER_DEANON_EVENT } from '../../../shared/constants'
import { onAbort } from './abort'

type Event = DeanonymizationProviderReadyEvent | DeanonymizationEvent
type Callback = (event: Event) => void

export const subscribeToApiDeanonymizationEvents = ({
  onEvent,
  signal,
}: {
  onEvent: Callback
  // Aborting removes the listener. The consent gate aborts on a denial and subscribes again on a
  // later grant, so a listener left behind would double every event from then on.
  signal?: AbortSignal
}): void => {
  const handler = (messageEvent: MessageEvent) => {
    const eventInfo = messageEvent.data
    if (eventInfo?.type !== CHILIPIPER_DEANON_EVENT) return

    let data: WebDataEvent
    try {
      data = JSON.parse(eventInfo.data) as WebDataEvent
    } catch {
      return
    }

    if (data.type === 'Api_Deanonymization_Event') {
      onEvent(data.event)
    }
  }

  window.addEventListener('message', handler)
  onAbort(signal, () => window.removeEventListener('message', handler))
}

export const subscribeToDeanonymizationSubmitted = ({
  onSubmitted,
}: {
  onSubmitted: (data: DeanonymizationEvent['data']) => void
}): void => {
  window.addEventListener('message', (messageEvent: MessageEvent) => {
    const eventInfo = messageEvent.data
    if (eventInfo?.type !== CHILIPIPER_DEANON_EVENT) return

    let data: WebDataEvent
    try {
      data = JSON.parse(eventInfo.data) as WebDataEvent
    } catch {
      return
    }

    if (data.type === 'Deanonymization_Submitted') {
      onSubmitted(data.data)
    }
  })
}
